import { useTranslation } from "react-i18next";
import { SolutionSelectedByDilemmaOwner } from "..";
import { DilemmaOwnerAnouncementText } from "../../molecules";
import { ChosenDilemmaCard } from "../../molecules/Board/subBoardComponents";
import { RenderStrengthCardType } from "../../molecules/StrengthCardsHolder/subStrengthCardsHolderComponents";

const StrengthCardsAreShownFullScreen = () => {
    const { t } = useTranslation();
    
    return (
        <div className="dilemma_owner_anouncement_wrapper dilemma_and_picked_solution_cards_wrapper center_horizontally_and_vertically full_screen_vw_vh">
            <DilemmaOwnerAnouncementText upperText={t("dilemmaOwnerShouldChooseAStrengthCardText")} middleText={t("thatBestFitText")} componentStyle="dilemma" isArrowShownTextBig={true}/>
            <div className="strength_cards_are_shown_full_screen_wrapper">
                <RenderStrengthCardType fullScreen={true} />
            </div>
            <div className="gradient_line_holder center_horizontally_and_vertically" style={{height: "3vh", width: "60%"}}>
                <div className="linear_gradient_line_horizontal" style={{ width: "100%" }}></div>
            </div> 
            <div className="dilemma_and_picked_solution_cards">
                <div className="dilemma_and_picked_solution_cards_dilemma"> 
                    <ChosenDilemmaCard isFullScreenOn={true} isTheFullScreenOn={true} />
                </div>
                <div className="dilemma_and_picked_solution_cards_solution">
                    <SolutionSelectedByDilemmaOwner /> 
                </div>
            </div>
        </div>
    )
}

export default StrengthCardsAreShownFullScreen;